import React from 'react';
import {OutlinedTextFieldProps} from '@mui/material';

// import VisibilityOff from '@mui/icons-material/VisibilityOff';
import TextField from 'components/inputs/TextField';

type PassphraseFieldProps = Partial<OutlinedTextFieldProps> & {
   hideButton?: boolean;
};

const PassphraseField = ({
   disabled,
   hideButton = disabled,
   type,
   ...restProps
}: PassphraseFieldProps) => {
   return <TextField type={type || 'password'} disabled={disabled} {...restProps} />;
};

export default PassphraseField;
